import { FC } from 'react';
import { ContentHeading } from 'components/Typography';
import RefundOptionsCard from './RefundOptionsCard';
import { useCancellationQuote } from '../CancellationQuoteProvider';

const RefundOptions: FC = () => {
  const { isEligibleForCreditNote } = useCancellationQuote();

  if (!isEligibleForCreditNote) {
    return null;
  }

  return (
    <>
      <ContentHeading>Refund options</ContentHeading>
      <RefundOptionsCard />
    </>
  );
};

export default RefundOptions;
